import { InfiniteData, QueryClient, QueryKey } from "@tanstack/react-query";
import { DealOptionsPage } from "types/crm/deal";

type DealOptionsCache = InfiniteData<DealOptionsPage>;

export const setDealOptionAssociated = (
  queryClient: QueryClient,
  scopeKey: readonly unknown[],
  dealUuid: string,
  associated: boolean,
) =>
  queryClient.setQueriesData<DealOptionsCache>(
    {
      predicate: (query) => query.queryKey.includes("options"),
    },
    (data) =>
      data && {
        ...data,
        pages: data.pages.map((page) => ({
          ...page,
          content: page.content.map((deal) =>
            deal.uuid === dealUuid ? { ...deal, associated } : deal,
          ),
        })),
      },
  );


export const restoreDealOptions = (
  queryClient: QueryClient,
  snapshot: [QueryKey, DealOptionsCache | undefined][] | undefined,
) => {
  snapshot?.forEach(([key, data]) => queryClient.setQueryData(key, data));
};
